export const monthlyReportConstants = {
  FETCH_MONTHLY_REPORT_START: 'FETCH_MONTHLY_REPORT_START',
  FETCH_MONTHLY_REPORT_SUCCESS: 'FETCH_MONTHLY_REPORT_SUCCESS',
  FETCH_MONTHLY_REPORT_FAILURE: 'FETCH_MONTHLY_REPORT_FAILURE',

  FETCH_MONTHLY_REPORT_CHART_START: 'FETCH_MONTHLY_REPORT_CHART_START',
  FETCH_MONTHLY_REPORT_CHART_SUCCESS: 'FETCH_MONTHLY_REPORT_CHART_SUCCESS',
  FETCH_MONTHLY_REPORT_CHART_FAILURE: 'FETCH_MONTHLY_REPORT_CHART_FAILURE',

  SET_MONTHLY_REPORT_SHARED_QUERIES: 'SET_MONTHLY_REPORT_SHARED_QUERIES',
  SET_MONTHLY_REPORT_TABLE_QUERIES: 'SET_MONTHLY_REPORT_TABLE_QUERIES',
  CLEAR_MONTHLY_REPORT_TABLE_RESPONSES: 'CLEAR_MONTHLY_REPORT_TABLE_RESPONSES',
  CLEAR_MONTHLY_REPORT_TABLE_QUERIES: 'CLEAR_MONTHLY_REPORT_TABLE_QUERIES',

  CLEAR_MONTHLY_REPORT_CHART_QUERIES: 'CLEAR_MONTHLY_REPORT_CHART_QUERIES',
  CLEAR_MONTHLY_REPORT_SHARED_QUERIES: 'CLEAR_MONTHLY_REPORT_SHARED_QUERIES',

  CLEAR_MONTHLY_REPORT_QUERIES_START: 'CLEAR_MONTHLY_REPORT_QUERIES_START'
};
